import { render, staticRenderFns } from "./SimpleCounterBlock.vue?vue&type=template&id=3c394a9d&scoped=true"
import script from "./SimpleCounterBlock.vue?vue&type=script&lang=js"
export * from "./SimpleCounterBlock.vue?vue&type=script&lang=js"
import style0 from "./SimpleCounterBlock.vue?vue&type=style&index=0&id=3c394a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c394a9d",
  null
  
)

export default component.exports